module.exports = __webpack_public_path__ + "img/space_bar.c752342b.svg";